import { TEXT_COLOR } from "../../../theme";

export const styles = {
  minimizeMaximizeButton: {
    color: TEXT_COLOR,
    zIndex: 1000,
    marginLeft: -1,
    marginTop: -2,
  } as const,
};
